import { lazy } from 'react';

export const PlayerRewardCreateForm = lazy(
  () => import('./PlayerRewardCreateForm'),
);
